import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
  ENVIORNMENTS,
  getBaseUrlOldForEnviornment,
  getCurrentEnviornment,
} from "utils/constants";

export function UseApiCallForOldDashboardData({
  url,
  method,
  body,
  skip = false,
}: any) {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>();
  const controllerRef = useRef<any>(null); // holds the current AbortController

  const baseUrl: any = getBaseUrlOldForEnviornment();

  const headers = {
    "Content-Type": "application/json",
  };

  useEffect(() => {
    if (!skip) {
      getData();
    }
  }, [skip]);

  async function getData() {
    // Cancel previous request
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;
    const requestConfig = {
      method,
      url: `${baseUrl}/${url}`,
      headers,
      data: JSON.stringify(body),
      timeout: 100000,
      signal: controller.signal,
    };
    try {
      setIsLoading(true);

      const response = await axios.request(requestConfig);

      setData(response?.data);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }

  function refetch() {
    getData();
  }

  return { data, isLoading, error, refetch };
}
